/**
 * Thin gtag wrapper. The global gtag / dataLayer are injected in index.html
 * (GA4 ID baked into the markup so it boots before React, which is what
 * Google's measurement quality docs recommend).
 *
 * If you spin up a separate Google Ads account later, set
 * `REACT_APP_GOOGLE_ADS_CONVERSION_ID` in frontend/.env to e.g.
 * `AW-1234567890/abcDEFghi-_` and we'll fire the conversion event as well.
 *
 * SPA route changes don't trigger automatic page_view events with `gtag.js`;
 * we ping `gtag('event','page_view',{ ... })` ourselves via `trackPageView`.
 */

const ADS_CONVERSION_ID =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID) || "";

function _gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackPageView(path) {
  _gtag("event", "page_view", {
    page_path: path || (typeof window !== "undefined" ? window.location.pathname : ""),
    page_location: typeof window !== "undefined" ? window.location.href : "",
  });
}

/** Fires GA4 `purchase` + (if configured) Google Ads `conversion`. */
export function trackPurchase({ orderNumber, value, currency = "USD", items = [] }) {
  if (!orderNumber) return;
  const payload = {
    transaction_id: orderNumber,
    value: Number(value || 0),
    currency,
    items: items.map((it) => ({
      item_id: it.sku || it.slug || it.id,
      item_name: it.name,
      price: Number(it.price || 0),
      quantity: Number(it.quantity || 1),
      item_category: it.category,
    })),
  };
  _gtag("event", "purchase", payload);
  if (ADS_CONVERSION_ID) {
    _gtag("event", "conversion", {
      send_to: ADS_CONVERSION_ID,
      value: payload.value,
      currency,
      transaction_id: orderNumber,
    });
  }
}

export function trackEvent(name, params = {}) {
  _gtag("event", name, params);
}
